import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';

const SearchContainer = ({
  setContainerName,
  setPage,
  width,
  placeholder,
  className,
}) => {
  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');

  // Debounce logic
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  // API call when debounced query changes
  useEffect(() => {
    searchContainerNumber(debouncedQuery);
  }, [debouncedQuery]);

  const searchContainerNumber = (searchTerm) => {
    setContainerName(searchTerm);
    setPage && setPage(1);
  };

  return (
    <div
      className={`${styles.searchContainer} ${className}`}
      style={{ width: width }}>
      <ReactSVG
        src={Icons.searchIcon}
        className={styles.search}
        beforeInjection={(svg) => {
          svg.querySelectorAll('path').forEach((path) => {
            path.setAttribute('stroke', '#99A0AE');
          });
        }}
      />
      <input
        type="text"
        className={styles.inputsearch}
        placeholder={placeholder || 'Search Container Number...'}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </div>
  );
};

export default SearchContainer;
